'use client'

import styled from 'styled-components'

export const CompareAtPrice = styled.span`
  text-decoration: line-through;
  color: ${o => o.theme.color.deprecated.obsidianLighter};
`
